import { Skeleton } from "antd";
import styled from "styled-components";

export const SkeletonAntd = styled(Skeleton)``;
